import {ajaxCommunity, getCommunityUrl, formatData, uploadImg} from "../request";
// 1GET 2POST 3PUT 4DELETE
//
const generalUrl = '/moment/generalMoments'
export default {
  // 举报帖子列表
  findSnsMemberActionByPage(data, method) {
    return ajaxCommunity("post", getCommunityUrl("/mgrMoment/report/postlist",1,generalUrl), data, {
      method,
    });
  },
  // 举报评论列表
  reportSnsMonitorRecord(data, method) {
    return ajaxCommunity("post", getCommunityUrl("/mgrMoment/report/commentlist",1,generalUrl), data, {
      method,
    });
  },
  // 处理帖子
  handlePostOperation(data, method) {
    return ajaxCommunity("post", getCommunityUrl("/mgrMoment/report/postlist/handle",2,generalUrl), data, {
      method,
    });
  },
  // 处理举报
  handleReportOperation(data, method) {
    return ajaxCommunity("post", getCommunityUrl("/mgrMoment/report/commentlist/handle",2,generalUrl), data, {
      method,
    });
  },
  // 解除社区封禁
  handleUnbanPost(data, method) {
    return ajaxCommunity("post", getCommunityUrl("/mgrMoment/permission/unblock/handle",2,generalUrl), data, {
      method,
    });
  },
  // 封禁社区 禁言
  handleBanPost(data, method) {
    return ajaxCommunity("post", getCommunityUrl("/mgrMoment/permission/block/handle",2,generalUrl), data, {
      method,
    });
  },
};



// WEBPACK FOOTER //
// ./src/js/https/communityApi.js